import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromPresentationMode from './state/presentation-mode/presentation-mode.reducer';
import { PresentationModeFacade } from './state/presentation-mode/presentation-mode.facade';
import * as fromCountriesTerritories from './state/country-territories/country-territories.reducer';
import { CountriesTerritoriesFacade } from './state/country-territories/country-territories.facade';
import * as fromUser from './state/user/user.reducer';
import { UserFacade } from './state/user/user.facade';
import * as fromFullscreen from './state/fullscreen/fullscreen.reducer';
import { FullscreenFacade } from './state/fullscreen/fullscreen.facade';
import * as fromUserPreferences from './state/user-preferences/user-preferences.reducer';
import { UserPreferencesFacade } from './state/user-preferences/user-preferences.facade';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromPresentationMode.PRESENTATION_MODE_KEY, fromPresentationMode.presentationModeReducer),
    StoreModule.forFeature(
      fromCountriesTerritories.COUNTRY_TERRITORIES_FEATURE_KEY,
      fromCountriesTerritories.countryAndTerritoriesReducer
    ),
    StoreModule.forFeature(fromFullscreen.FULLSCREEN_FEATURE_KEY, fromFullscreen.fullscreenReducer),
    StoreModule.forFeature(fromUser.USER_FEATURE_KEY, fromUser.userReducer),
    StoreModule.forFeature(fromUserPreferences.USER_PREFERENCES_KEY, fromUserPreferences.userPreferencesReducer),
  ],
  providers: [CountriesTerritoriesFacade, PresentationModeFacade, UserFacade, FullscreenFacade, UserPreferencesFacade],
})
export class GlobalConfigStoreModule {}
